import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { isNone as t } from "../../../../../core/maybe.js";
import e from "../MemoryBuffer.js";

var n = /*#__PURE__*/function () {
  function n(t) {
    _classCallCheck(this, n);

    this._locations = new Map(), this._key = t;
  }

  _createClass(n, [{
    key: "key",
    get: function get() {
      return this._key;
    }
  }, {
    key: "type",
    get: function get() {
      return 7 & this._key;
    }
  }, {
    key: "defines",
    value: function defines() {
      return [];
    }
  }, {
    key: "getStride",
    value: function getStride() {
      return this._layoutInfo || this._buildAttributesInfo(), this._stride;
    }
  }, {
    key: "getAttributeLocations",
    value: function getAttributeLocations() {
      return 0 === this._locations.size && this._buildAttributesInfo(), this._locations;
    }
  }, {
    key: "getLayoutInfo",
    value: function getLayoutInfo() {
      return this._layoutInfo || this._buildAttributesInfo(), this._layoutInfo;
    }
  }, {
    key: "getEncodingInfos",
    value: function getEncodingInfos() {
      return this._propertyEncodingInfo || this._buildAttributesInfo(), this._propertyEncodingInfo;
    }
  }, {
    key: "getUniforms",
    value: function getUniforms() {
      return this._uniforms || this._buildAttributesInfo(), this._uniforms;
    }
  }, {
    key: "getShaderHeader",
    value: function getShaderHeader() {
      return this._shaderHeader || this._buildAttributesInfo(), this._shaderHeader;
    }
  }, {
    key: "getShaderMain",
    value: function getShaderMain() {
      return this._shaderMain || this._buildAttributesInfo(), this._shaderMain;
    }
  }, {
    key: "setDataUniforms",
    value: function setDataUniforms(t, e, _n, o, s) {
      var r = this.getUniforms();

      var _iterator = _createForOfIteratorHelper(r),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var i = _step.value;
          var _r = i.name,
              a = i.type,
              c = i.getValue,
              u = c(_n, e, o, s);
          if (null !== u) switch (a) {
            case "float":
              t.setUniform1f(_r, u);
              break;

            case "vec2":
              t.setUniform2fv(_r, u);
              break;

            case "vec4":
              t.setUniform4fv(_r, u);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "encodeAttributes",
    value: function encodeAttributes(t, e, _n2, o) {
      var s = this.attributesInfo(),
          r = this.getEncodingInfos(),
          i = [];
      var a = 0,
          c = 0;

      for (var _i = 0, _Object$keys = Object.keys(r); _i < _Object$keys.length; _i++) {
        var f = _Object$keys[_i];
        var u;

        var d = r[f],
            _s$f = s[f],
            h = _s$f.type,
            l = _s$f.precisionFactor,
            y = _s$f.isLayout,
            _ = y ? _n2.getLayoutProperty(f) : _n2.getPaintProperty(f),
            m = null == (u = _.interpolator) ? void 0 : u.getInterpolationRange(e);

        var b = 0;

        var _iterator2 = _createForOfIteratorHelper(d),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _n16 = _step2.value;
            var _s = _n16.offset,
                _r2 = _n16.bufferElementsToAdd;

            if (_r2 > 0) {
              for (var _t = 0; _t < _r2; _t++) {
                i.push(0);
              }

              a += c, c = _n16.bufferElementsToAdd;
            }

            var _u = null != o ? o : _.getValue(m ? m[b] : e, t);

            switch (h) {
              case 0:
              case 1:
                i[a] |= this._encodeByte(_u * (l || 1), 8 * _s);
                break;

              case 2:
              case 3:
                i[a] |= this._encodeShort(_u * (l || 1), 8 * _s);
                break;

              case 4:
              case 5:
                i[a] |= this._encodeByte(_u * (l || 1), 8 * _s), i[a] |= this._encodeByte(_u * (l || 1), 8 * _s + 8);
                break;

              case 6:
              case 7:
                i[a] |= this._encodeShort(_u * (l || 1), 8 * _s), i[a] |= this._encodeShort(_u * (l || 1), 8 * _s + 16);
                break;

              case 8:
              case 9:
                i[a] |= this._encodeByte(_u * (l || 1), 8 * _s), i[a] |= this._encodeByte(_u * (l || 1), 8 * _s + 8), i[a] |= this._encodeByte(_u * (l || 1), 8 * _s + 16), i[a] |= this._encodeByte(_u * (l || 1), 8 * _s + 24);
                break;

              case 10:
                i[a] = this._encodeColor(_u);
                break;

              case 11:
              case 12:
                this._encodePattern(a, i, _u);

                break;

              default:
                throw new Error("Unsupported encoding type");
            }

            b++;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }

      return i;
    }
  }, {
    key: "getAtributeState",
    value: function getAtributeState(t) {
      var e = 0;

      var _n4 = 3 + 2 * t;

      return e |= this._bit(_n4), e |= this._bit(_n4 + 1) << 1, e;
    }
  }, {
    key: "_buildAttributesInfo",
    value: function _buildAttributesInfo() {
      var t = [],
          e = {},
          o = {};
      var s = -1;
      var r = this.attributesInfo(),
          i = this.attributes();
      var a = -1;

      var _iterator3 = _createForOfIteratorHelper(i),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var d = _step3.value;
          a++;

          var _i3 = this.getAtributeState(a);

          if (0 === _i3 || 3 === _i3) continue;
          var _c = r[d],
              _u2 = [];
          e[d] = _u2;
          var _f = _c.type;

          for (var _e = 0; _e < _i3; _e++) {
            var _n$_encodingInfo$_f = n._encodingInfo[_f],
                _e2 = _n$_encodingInfo$_f.dataType,
                _r3 = _n$_encodingInfo$_f.bytesPerElement,
                _i4 = _n$_encodingInfo$_f.count,
                _a = _n$_encodingInfo$_f.normalized,
                _c2 = _r3 * _i4;

            var _d = o[_e2],
                h = 0;
            if (!_d || _d.count + _i4 > 4) s++, _d = {
              dataIndex: s,
              count: 0,
              offset: 0
            }, 4 !== _i4 && (o[_e2] = _d), t.push({
              location: -1,
              name: "a_data_" + s,
              count: _i4,
              type: _e2,
              normalized: _a
            }), h = Math.ceil(Math.max(_c2 / 4, 1));else {
              var _e3 = t[_d.dataIndex];
              _e3.count += _i4;
              h = Math.ceil(Math.max(_e3.count * _r3 / 4, 1)) - Math.ceil(Math.max(_d.offset / 4, 1));
            }
            _u2.push({
              dataIndex: _d.dataIndex,
              offset: _d.offset,
              bufferElementsToAdd: h
            }), _d.offset += _c2, _d.count += _i4;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      for (var _i2 = 0, _t2 = t; _i2 < _t2.length; _i2++) {
        var _n17 = _t2[_i2];

        switch (_n17.type) {
          case 5120:
          case 5121:
            _n17.count = 4;

          case 5122:
          case 5123:
            _n17.count += _n17.count % 2;
        }
      }

      this._buildVertexBufferLayout(t);

      var c = 0;
      var u = this._layoutInfo.geometry;

      var _iterator4 = _createForOfIteratorHelper(u),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _n19 = _step4.value;

          this._locations.set(_n19.name, c++);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      var f = this._layoutInfo.opacity;

      if (f) {
        var _iterator5 = _createForOfIteratorHelper(f),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var _n18 = _step5.value;

            this._locations.set(_n18.name, c++);
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }

      this._buildShaderInfo(t, e), this._propertyEncodingInfo = e;
    }
  }, {
    key: "_buildVertexBufferLayout",
    value: function _buildVertexBufferLayout(t) {
      var e = {},
          _n8 = this.geometryInfo();

      var s = _n8[0].stride;
      if (0 === t.length) e.geometry = _n8;else {
        var r = [];
        var i = s;

        var _iterator6 = _createForOfIteratorHelper(t),
            _step6;

        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var _e4 = _step6.value;
            s += o(_e4.type) * _e4.count;
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }

        var _iterator7 = _createForOfIteratorHelper(_n8),
            _step7;

        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var _t3 = _step7.value;

            var _e5 = _objectSpread({}, _t3);

            _e5.stride = s, r.push(_e5);
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }

        var _iterator8 = _createForOfIteratorHelper(t),
            _step8;

        try {
          for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
            var _e6 = _step8.value;
            r.push({
              name: _e6.name,
              count: _e6.count,
              type: _e6.type,
              offset: i,
              stride: s,
              normalized: _e6.normalized || !1,
              divisor: 0
            }), i += o(_e6.type) * _e6.count;
          }
        } catch (err) {
          _iterator8.e(err);
        } finally {
          _iterator8.f();
        }

        e.geometry = r;
      }
      this.opacityInfo() && (e.opacity = this.opacityInfo()), this._layoutInfo = e, this._stride = s;
    }
  }, {
    key: "_buildShaderInfo",
    value: function _buildShaderInfo(e, o) {
      var _this = this;

      var r = "\n",
          i = "\n";
      var a = [];

      var _iterator9 = _createForOfIteratorHelper(e),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var _t4 = _step9.value;
          r += "attribute ".concat(this._getType(_t4.count), " ").concat(_t4.name, ";\n");
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }

      var c = this.attributes(),
          u = this.attributesInfo();
      var f = -1;

      var _iterator10 = _createForOfIteratorHelper(c),
          _step10;

      try {
        var _loop = function _loop() {
          var d = _step10.value;
          f++;

          var _u$d = u[d],
              e = _u$d.name,
              c = _u$d.type,
              h = _u$d.precisionFactor,
              l = _u$d.isLayout,
              y = h && 1 !== h ? " * " + 1 / h : "",
              _n$_encodingInfo$c = n._encodingInfo[c],
              _ = _n$_encodingInfo$c.bytesPerElement,
              m = _n$_encodingInfo$c.count,
              b = function b(t) {
            return "a_data_".concat(t.dataIndex).concat(s(m, t.offset, _));
          };

          switch (_this.getAtributeState(f)) {
            case 0:
              {
                var _n20 = _this._getType(m),
                    _o = "u_".concat(e);

                a.push({
                  name: _o,
                  type: _n20,
                  getValue: function getValue(e, _n10, o, s) {
                    var r = l ? e.getLayoutValue(d, _n10) : e.getPaintValue(d, _n10);

                    if (11 === c) {
                      var _o2 = e.getDashKey(r, e.getLayoutValue("line-cap", _n10)),
                          _i5 = s.getMosaicItemPosition(_o2, !1);

                      if (t(_i5)) return null;
                      var _a2 = _i5.tl,
                          _c3 = _i5.br;
                      return [_a2[0], _c3[1], _c3[0], _a2[1]];
                    }

                    if (12 === c) {
                      var _e7 = s.getMosaicItemPosition(r, -1 === d.indexOf("line-"));

                      if (t(_e7)) return null;
                      var _n21 = _e7.tl,
                          _o3 = _e7.br;
                      return [_n21[0], _o3[1], _o3[0], _n21[1]];
                    }

                    if (10 === c) {
                      var _t5 = r[3];
                      return [_t5 * r[0], _t5 * r[1], _t5 * r[2], _t5];
                    }

                    return r;
                  }
                }), r += "uniform ".concat(_n20, " ").concat(_o, ";\n"), i += "".concat(_n20, " ").concat(e, " = ").concat(_o, ";\n");
              }
              break;

            case 1:
              {
                var _t6 = b(o[d][0]);

                i += "".concat(_this._getType(m), " ").concat(e, " = ").concat(_t6).concat(y, ";\n");
              }
              break;

            case 2:
              {
                var _t7 = "u_t_".concat(e);

                a.push({
                  name: _t7,
                  type: "float",
                  getValue: function getValue(t, e, _n13, o) {
                    return (l ? t.getLayoutProperty(d) : t.getPaintProperty(d)).interpolator.interpolationUniformValue(_n13, e);
                  }
                }), r += "uniform float ".concat(_t7, ";\n");

                var _n22 = b(o[d][0]),
                    _s2 = b(o[d][1]);

                i += "".concat(_this._getType(m), " ").concat(e, " = mix(").concat(_n22).concat(y, ", ").concat(_s2).concat(y, ", ").concat(_t7, ");\n");
              }
          }
        };

        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }

      this._shaderHeader = r, this._shaderMain = i, this._uniforms = a;
    }
  }, {
    key: "_bit",
    value: function _bit(t) {
      return (this._key & 1 << t) >> t;
    }
  }, {
    key: "_getType",
    value: function _getType(t) {
      switch (t) {
        case 1:
          return "float";

        case 2:
          return "vec2";

        case 3:
          return "vec3";

        case 4:
          return "vec4";
      }

      throw new Error("Invalid count");
    }
  }, {
    key: "_encodeColor",
    value: function _encodeColor(t) {
      var _n14 = 255 * t[3];

      return e.i8888to32(t[0] * _n14, t[1] * _n14, t[2] * _n14, _n14);
    }
  }, {
    key: "_encodePattern",
    value: function _encodePattern(t, e, _n15) {
      if (!_n15 || !_n15.rect) return;
      var o = 2,
          s = _n15.rect,
          r = _n15.width,
          i = _n15.height;
      e[t] = this._encodeShort(s.x + o, 0), e[t] |= this._encodeShort(s.y + o + i, 16), e[t + 1] = this._encodeShort(s.x + o + r, 0), e[t + 1] |= this._encodeShort(s.y + o, 16);
    }
  }, {
    key: "_encodeByte",
    value: function _encodeByte(t, e) {
      return (255 & t) << e;
    }
  }, {
    key: "_encodeShort",
    value: function _encodeShort(t, e) {
      return (65535 & t) << e;
    }
  }]);

  return n;
}();

n._encodingInfo = {
  0: {
    dataType: 5120,
    bytesPerElement: 1,
    count: 1,
    normalized: !1
  },
  1: {
    dataType: 5121,
    bytesPerElement: 1,
    count: 1,
    normalized: !1
  },
  2: {
    dataType: 5122,
    bytesPerElement: 2,
    count: 1,
    normalized: !1
  },
  3: {
    dataType: 5123,
    bytesPerElement: 2,
    count: 1,
    normalized: !1
  },
  4: {
    dataType: 5120,
    bytesPerElement: 1,
    count: 2,
    normalized: !1
  },
  5: {
    dataType: 5121,
    bytesPerElement: 1,
    count: 2,
    normalized: !1
  },
  6: {
    dataType: 5122,
    bytesPerElement: 2,
    count: 2,
    normalized: !1
  },
  7: {
    dataType: 5123,
    bytesPerElement: 2,
    count: 2,
    normalized: !1
  },
  8: {
    dataType: 5120,
    bytesPerElement: 1,
    count: 4,
    normalized: !1
  },
  9: {
    dataType: 5121,
    bytesPerElement: 1,
    count: 4,
    normalized: !1
  },
  10: {
    dataType: 5121,
    bytesPerElement: 1,
    count: 4,
    normalized: !0
  },
  11: {
    dataType: 5123,
    bytesPerElement: 2,
    count: 4,
    normalized: !1
  },
  12: {
    dataType: 5123,
    bytesPerElement: 2,
    count: 4,
    normalized: !1
  }
};

var o = function o(t) {
  switch (t) {
    case 5126:
    case 5124:
    case 5125:
      return 4;

    case 5122:
    case 5123:
      return 2;

    case 5120:
    case 5121:
      return 1;
  }
},
    s = function s(t, e, n) {
  var o = e / n;
  if (1 === t) switch (o) {
    case 0:
      return ".x";

    case 1:
      return ".y";

    case 2:
      return ".z";

    case 3:
      return ".w";
  } else if (2 === t) switch (o) {
    case 0:
      return ".xy";

    case 1:
      return ".yz";

    case 2:
      return ".zw";
  } else if (3 === t) switch (o) {
    case 0:
      return ".xyz";

    case 1:
      return ".yzw";
  }
  return "";
};

export { n as VTLMaterial };